export type CalculateTimeLeftResult = {
    days: string;
    hours: string;
    minutes: string;
    seconds: string;
    isTimeUp: boolean;
    isValidDate: boolean;
};

export const calculateTimeLeft = (dateTo: string, isDisplayDay = false): CalculateTimeLeftResult => {
    const defaultTimeLeft: CalculateTimeLeftResult = {
        days: '0',
        hours: '0',
        minutes: '00',
        seconds: '00',
        isTimeUp: true,
        isValidDate: false,
    };
    const currentDate = new Date();
    const targetDate = new Date(dateTo);
    if (Number.isNaN(targetDate.getTime())) {
        return defaultTimeLeft;
    }
    const timeLeft = targetDate.getTime() - currentDate.getTime();

    if (timeLeft <= 0) {
        defaultTimeLeft.isValidDate = true;
        return defaultTimeLeft;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = isDisplayDay ? Math.floor((timeLeft / 1000 / 60 / 60) % 24) : Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
    const seconds = Math.floor((timeLeft / 1000) % 60);

    const calculateTimeLeftResult = {
        days: (days < 10 ? '0' : '') + days,
        hours: (hours < 10 ? '0' : '') + hours,
        minutes: ('0' + minutes).slice(-2),
        seconds: ('0' + seconds).slice(-2),
        isTimeUp: false,
        isValidDate: true,
    };
    return calculateTimeLeftResult;
};

export const calculateTimePass = (dateFrom: string, dateTo: string): number => {
    const fromDate = new Date(dateFrom);
    const toDate = new Date(dateTo);
    const fromDateMilliseconds = fromDate.getTime();
    const toDateMilliseconds = toDate.getTime();

    if (Number.isNaN(fromDateMilliseconds) || Number.isNaN(toDateMilliseconds)) {
        return 0;
    }

    const currentDate = new Date();

    if (fromDate > currentDate) {
        return 0;
    } else if (currentDate > toDate) {
        return 100;
    }

    const currentDateMilliseconds = currentDate.getTime();
    const totalTime = toDateMilliseconds - fromDateMilliseconds;
    const timePassed = currentDateMilliseconds - fromDateMilliseconds;
    const percentagePassed = (timePassed / totalTime) * 100;

    return percentagePassed;
};

export const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
};

export const isActiveDate = (fromDate?: string, endDate?: string): boolean => {
    const now = new Date();

    if (endDate) {
        const [y, m, d] = endDate.split('-').map(Number);
        const end = new Date(y, m - 1, d, 0, 0, 0, 0);

        if (now >= end) return false;
    }

    if (fromDate) {
        const [y, m, d] = fromDate.split('-').map(Number);
        const start = new Date(y, m - 1, d, 0, 0, 0, 0);

        if (now < start) return false;
    }

    return true;
};
